module.exports = __webpack_public_path__ + "static/img/m1.1134987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m1.jpg
// module id = 00Oa
// module chunks = 1